import { render, staticRenderFns } from "./fanzoneModal.vue?vue&type=template&id=22529eec&scoped=true"
import script from "./fanzoneModal.vue?vue&type=script&lang=js"
export * from "./fanzoneModal.vue?vue&type=script&lang=js"
import style0 from "./fanzoneModal.vue?vue&type=style&index=0&id=22529eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22529eec",
  null
  
)

export default component.exports